import { createUsersApi } from "../api-helpers/UserApiHelper";
import { UsersDto } from "users-experience-client";

const usersApi = createUsersApi();

const cache = new Map<string, string>();

export const loadData = async (): Promise<void> => {
  const response = await usersApi.usersControllerFindAll();
  if (Array.isArray(response.data)) {
    response.data.forEach((user) => cache.set(user.id, getName(user)));
  }
 


};

function getName(user: UsersDto): string {
  return user.firstName + " " + user.lastName;
}

export interface Props {
  userId?: string;
}

export const UserName = ({ userId }: Props) => {
  return <>{userId ? cache.get(userId) ?? "-" : "-"}</>;
};
